import React from 'react';

const Home = () => {

    return (
        <div className='mt-2'>
            <h1>Главная страница</h1>
            <h3>Добро пожаловать в web-приложение магазина техники i-Bozh!</h3>
            <h3>Здесь вы можете приобрести полезные и приемлемые по цене товары!</h3>
        </div>
    );
};
export default Home;